import React, { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { IMG } from "@/lib/api";
import { PageHeader } from "@/components/shared/SectionHeader";
import { FileText, Download, Search, Bookmark } from "lucide-react";

const CATS = ["All", "Checklists", "Guides", "Worksheets", "Infographics", "Nutrition Charts", "Veterinary Resources", "Recommended Books"];

export default function Resources() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("All");
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/resources").then(r => setItems(r.data)); }, []);

  const filtered = useMemo(() => items.filter(r =>
    (cat === "All" || r.category === cat) &&
    (q === "" || (r.title + " " + r.description).toLowerCase().includes(q.toLowerCase()))
  ), [items, cat, q]);

  return (
    <div>
      <PageHeader
        eyebrow="Resource Library"
        title="A living archive for the wolfdog world."
        description="Search downloadable guides, worksheets, infographics and research from our faculty and partners."
        image={IMG.forest}
      />

      <section className="container-x py-14">
        <div className="flex flex-col md:flex-row md:items-center gap-4 justify-between">
          <div className="flex flex-wrap gap-2">
            {CATS.map(c => (
              <button key={c} onClick={() => setCat(c)}
                data-testid={`resource-cat-${c.toLowerCase().replace(/\s+/g,'-')}`}
                className={"text-xs uppercase tracking-[0.2em] font-semibold px-3 py-2 rounded-full border transition " + (cat === c ? "bg-primary text-primary-foreground border-primary" : "border-border text-muted-foreground hover:border-foreground/40")}>{c}</button>
            ))}
          </div>
          <div className="relative w-full md:w-80">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search resources…" data-testid="resource-search"
              className="w-full pl-9 pr-4 py-3 text-sm rounded-md border border-border bg-background focus:outline-none focus:ring-2 focus:ring-primary" />
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map(r => (
            <div key={r.id} data-testid={`resource-${r.id}`} className="rounded-lg border border-border bg-card p-6 hover:-translate-y-1 transition flex flex-col gap-3">
              <div className="flex items-start justify-between">
                <div className="h-11 w-11 rounded-md bg-accent/15 text-accent grid place-items-center">
                  <FileText className="h-5 w-5" />
                </div>
                <span className="text-[10px] uppercase tracking-widest font-semibold text-muted-foreground">{r.kind}</span>
              </div>
              <div className="font-display text-xl leading-snug">{r.title}</div>
              <div className="text-sm text-muted-foreground line-clamp-2">{r.description}</div>
              <div className="flex items-center justify-between pt-2 border-t border-border">
                <span className="eyebrow text-[10px]">{r.category}</span>
                <div className="flex items-center gap-1">
                  <button className="h-8 w-8 grid place-items-center hover:text-primary" aria-label="Bookmark"><Bookmark className="h-4 w-4" /></button>
                  <button className="h-8 w-8 grid place-items-center hover:text-primary" aria-label="Download"><Download className="h-4 w-4" /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
